export enum DEPLOYMENT_STAGES {
    Playground = 'playground'
}

export const DEFAULT_OVERRIDE_TENANT_ID = 'federated-sso-playground';

export class IntegrationUtils {
    private static processEnv: NodeJS.ProcessEnv | undefined;
    public static init(buildObj: NodeJS.ProcessEnv) {
        if (this.processEnv === undefined) {
            this.processEnv = buildObj;
        }
    }
    public static canFunctionAutonomously(): boolean {
        switch(this.processEnv?.REACT_APP_STAGE) {
            case DEPLOYMENT_STAGES.Playground:
                return true;
            default:
                return false;
        }
    }
}
